module.exports = __webpack_public_path__ + "static/media/60.8e7f68b3.jpg";